/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 同行者到着タイプ
 */
export type BaseInfoRelatedPersonAttendantArrivalTypeEnum =
  (typeof BaseInfoRelatedPersonAttendantArrivalTypeEnum)[keyof typeof BaseInfoRelatedPersonAttendantArrivalTypeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseInfoRelatedPersonAttendantArrivalTypeEnum = {
  FOLLOW_UP: 'FOLLOW_UP',
  RIDE_ALONG: 'RIDE_ALONG',
} as const;
